<template>
  <div class="fillcontain">
    <head-top></head-top>
    <div class="table_container">
      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-form :inline="true" :model="filters">
          <el-form-item>
            <el-form-item>
              <el-select v-model="value">
                <el-option
                  v-for="item in categoryOptions"
                  :key="item.id"
                  :label="item.label"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-input v-model="filters.name" placeholder="用户昵称"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="currentPage=1,getuserList()">搜索</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <el-table
        :data="tableData"
        style="width: 100%">
        <el-table-column
          label="序号"
          type="index"
          width="70">
        </el-table-column>
        <el-table-column
          label="用户昵称"
          prop="account">
        </el-table-column>
        <el-table-column
          label="手机号"
          prop="phone">
        </el-table-column>
        <el-table-column
          label="分类">
          <template slot-scope="scope">
            <el-button size="mini" v-if="scope.row.menmberNum =='0'" type="text" >普通用户</el-button>
            <el-button size="mini" v-if="scope.row.menmberNum =='1'" type="text" >VIP会员</el-button>
          </template>
        </el-table-column>
        <el-table-column
          label="积分"
          prop="integral">
        </el-table-column>
        <el-table-column
          :formatter="formatDate"
          label="注册时间"
          prop="createTime">
        </el-table-column>
        <!--<el-table-column-->
          <!--label="操作"-->
          <!--fixed="right"-->
          <!--width="180">-->
          <!--<template slot-scope="scope">-->
            <!--<el-button size="mini" v-if="scope.row.status == '0'" type="text" @click="getblack(scope.$index, scope.row)">解除拉黑</el-button>-->
            <!--<el-button size="mini" v-if="scope.row.status == '1'" type="text" @click="getblack(scope.$index, scope.row)">拉黑</el-button>-->
          <!--</template>-->
        <!--</el-table-column>-->
      </el-table>

      <div class="Pagination">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="20"
          layout="total, prev, pager, next"
          :total="total">
        </el-pagination>
      </div>

    </div>
  </div>
</template>

<script>
  import headTop from '../components/headTop'
  import { getuserList,getpullBlack } from "../api/api"
  export default {
    data () {
      return {
        value: '',
        filters: {
          name: ''
        },
        tableData: [],
        limit: 20,
        total: 0,
        currentPage: 1,
        categoryOptions: [{
            id:'',
            label:'全部'
          },{
            id:'0',
            label:'普通用户'
          },{
            id:'1',
            label:'VIP用户'
          },{
            id:'-1',
            label:'黑名单用户'
        }],
        status:'',
      }
    },
    components: {
      headTop,
    },
    methods: {
      //时间戳转换
      formatDate: function (value) {
        var dateee = new Date(value.createTime).toJSON();
        return new Date(+new Date(dateee) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
      },
      handleCurrentChange (val) {
        this.currentPage = val;
        this.getuserList()
      },
      // getuserList () {
      //   let params = {
      //     pageNum: this.currentPage,
      //     pageSize: this.limit,
      //     menmberNum:'',
      //     account:'',
      //     status:''
      //   };
      //   getuserList(params).then(res => {
      //     this.tableData = res.pageInfo
      //     this.total = res.total
      //   }).catch(error => {
      //     console.log(error);
      //   })
      // },

      getuserList () {
        //  查询
        if (this.value == '-1'){
          this.status = 0
        } else {
          this.status = ''
        }
        let params = {
          pageNum: this.currentPage,
          pageSize: this.limit,
          menmberNum:this.value,
          account:this.filters.name,
          status:this.status
        };
        getuserList(params).then(res => {
          this.tableData = res.pageInfo
          this.total = res.total
        }).catch(error => {
          console.log(error);
        })
      },
      getblack(index,row){
        this.$confirm('确认拉黑或解除拉黑？', '提示', {
          // type: 'warning'
        }).then(() => {
          if (row.status == 1){
            this.status = 0
          } else {
            this.status = 1
          }
          let params = {
            id: row.id,
            status: this.status,
          };
          getpullBlack(params).then(res => {
            if (row.status == 1){
              row.status = 0
            } else {
              row.status = 1
            }
          }).catch(error => {
            console.log(error);
          })
        })
      },
    },
    created (){
      this.getuserList()
    },
  }
</script>

<style lang="less">
  @import '../style/mixin';
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
</style>



// WEBPACK FOOTER //
// src/page/user.vue